<template>
	<div :class="['permits-item', {'permits-item--has-action': hasAction}]" @click="onAction_ClickHandler" :style="style">
		<div class="permits-item__content">
			<slot></slot>
		</div>
		<div class="permits-item__footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'permits-item',
	props: {
		hasAction: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: '#fff'
		}
	},
	computed: {
		style() {
			const default_styles = {
				backgroundColor: this.color,
			}
			return Object.assign(default_styles, this.customStyles)
		}
	},
	methods: {
		onAction_ClickHandler() {
			if (!this.hasAction)
				return
			this.$emit('click', {})
		}
	}
}
</script>

<style scoped>
.permits-item {
	border-radius: 3px;
	background: #fff;
	box-shadow: rgba(0,0,0,0.2) 1px 1px 5px;
}
.permits-item__content {
	width: 100%;
	height: 90px;
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}
.permits-item.permits-item--has-action {
	cursor: pointer;
}
.permits-item.permits-item--has-action > .permits-item__content {
	transform-origin: left center;
	background-color: rgba(0,0,0,0);
	transform: translate(0, 0) scale(1, 1);
	transition: all 0.3s;
}
.permits-item.permits-item--has-action:hover > .permits-item__content {
	background-color: rgba(0,0,0,0.01);
	transform: translate(5px, 0) scale(1, 1);
}
.permits-item__footer {
	display: flex;
	background-color: rgba(0,0,0,0.2);
	height: 55px;
	align-items: center;
	justify-content: flex-end;
}
.permits-item__content h1 {
	font-size: 14px;
	font-weight: 900;
	color: #fff;
	border: 0;
	text-transform: none;
	padding: 0 20px 0 5px;
	margin: 20px 0 5px 0;
}
.permits-item__content p {
	padding: 0 20px 0 5px;
	font-size: 13px;
	line-height: 1.35em;
	color: #fff;
	margin: 0;
}
.permits-item__footer button {
	width: 100%;
	flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/modules/permits/PermitsItem.vue